import axiosInstance from "@API/axios";
import { useState } from "react";
import { useDispatch } from "react-redux";
import { setSnackbar } from "@Redux/snackBarSlice";

const useSendGetRequest = (showSnackBar = false, isBinary = false) => {
  const dispatch = useDispatch();
  const [loading, setLoading] = useState(false);
  const getData = (url, params) => {
    setLoading(true);

    // Configure axios options for binary data
    const axiosConfig = {
      params,
      ...(isBinary && {
        responseType: "blob",
        headers: {
          Accept: "application/pdf, application/octet-stream",
        },
      }),
    };

    return axiosInstance
      .get(url, axiosConfig)
      .then((response) => {
        setLoading(false);
        return isBinary ? response.data : response.data;
      })
      .catch((error) => {
        setLoading(false);
        if (showSnackBar) {
          dispatch(
            setSnackbar({
              open: true,
              message:
                typeof error.response?.data === "object"
                  ? error.response?.data.details
                  : error.response?.data || "Internal Server Error.",
              error: true,
            })
          );
        }
        throw error;
      });
  };
  return { loading, getData };
};

export default useSendGetRequest;
